const customerListId = {
	customer_list: {
		title: "Daftar Pelanggan",
		table: {
			title: "Data Pelanggan",
			columns: {
				store: "Toko",
				name: "Nama",
				email: "Email",
				phone_number: "Nomor Hp",
				id_card: "Nomor Kartu",
				points: "Jumlah Poin",
				status: "Status",
			},
		},
		forms: {
			import: {
				button: "Impor Pelanggan",
				title: "Impor Pelanggan",
				description: "Impor data pelanggan",
			},
			edit: {
				title: "Ubah Pelanggan",
				description: "Ubah data pelanggan",
				info: "Informasi Pelanggan",
				fields: {
					store: {
						label: "Toko",
						placeholder: "Pilih Toko",
						not_found: "Toko tidak ditemukan",
					},
					phone_number: {
						label: "Nomor HP",
						placeholder: "Masukkan nomor hp",
					},
					id_card: {
						label: "Nomor Kartu",
						placeholder: "Masukkan nomor kartu",
					},
					points: {
						label: "Jumlah Poin",
						placeholder: "Masukkan jumlah poin",
					},
					status: {
						placeholder: "Pilih Status",
					},
				},
			},
			delete: {
				title: "Hapus Pelanggan",
				description: "Apakah kamu yakin ingin menghapus {name}?",
			},
		},
		actions: {
			save: "Simpan",
			saving: "Menyimpan...",
			cancel: "Batal",
			save_changes: "Simpan Perubahan",
			saving_changes: "Menyimpan Perubahan...",
			delete: "Hapus",
			deleting: "Menghapus...",
			upload: "Unggah",
			uploading: "Mengungah...",
		},
		status: {
			active: "Aktif",
			inactive: "Tidak Aktif",
		},
		empty_state: {
			title: "Tidak ada data customer",
			description: "Silakan tambahkan customer baru.",
		},
	},
};

export default customerListId;
